
<div class="agpr-colorSwatch">
@if (colors?.length > 0) {
    <ul
        [id]="id + '_swatchList'"
        class="agpr-colorSwatchGrid"
        [attr.aria-label]="ariaLabel | localize"
        agprListKeyboardNavigation
        listOrientation="horizontal"
        [focusOnChild]="true"
        [list]="colors"
        [initialFocusIndex]="colors.indexOf(_hexValue)">
        @for (color of colors.slice(0, maxColors); track color) {
            <li>
                <agpr-button
                    [id]="id + '_swtach_' + $index"
                    class="agpr-colorSwatchGrid-swatch"
                    [class.agpr-colorSwatchGrid-swatch--active]="color === _hexValue"
                    [style.background-color]="color"
                    [style]="buttonTypesEnum.colorSwatch"
                    (click)="selectColor(color)"
                    [ariaLabel]="'ColorPicker.selectColor' | localize: { color }"
                    [tooltip]="showTooltip ? color : ''"
                    [forceTooltipOnFocus]="true"
                    tooltipPosition="top"
                ></agpr-button>
            </li>
        }
    </ul>
} @else {
    <span class="agpr-colorSwatch-emptyMessage">
        {{ emptyMessage | localize }}
    </span>
}
</div>